/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Fragment, ReactNode, useState } from 'react';
import {
    Menu,
    Transition,
} from "@headlessui/react";

import { DeleteConsultant } from "../../api/Consultation/DeleteConsultant";

import DeleteModal from "../Shared/DeleteModal";
import { toast } from 'react-toastify';
import { CalendarCheck, Pencil, Trash2 } from 'lucide-react';
import {
    DashboardActionMenuPanel,
    DashboardMenuButton,
    DashboardMenuLink,
    dashboardActionMenuButtonClass,
} from '../Dashboard/Shared/DashboardActionMenu';

const ConsultantDropdown = ({ children, consultantId }: { children?: ReactNode, consultantId: string; }) => {
    const [isOpen, setIsOpen] = useState(false);


    const handleDelete = async (id: string) => {
        await DeleteConsultant(id);
        toast.success("Consultant deleted successfully");
    };



    return (
        <div className="relative ">
            <DeleteModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                mutationFn={handleDelete}
                itemId={consultantId}
                queryKey="consultants"
            />

            <Menu as="div" className="relative inline-block">
                <div>
                    <Menu.Button className={dashboardActionMenuButtonClass}>
                        {children}
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <DashboardActionMenuPanel>
                        <DashboardMenuLink icon={CalendarCheck} to={`/dashboard/consultants/reservations/${consultantId}`}>
                            Reserved Consultants
                        </DashboardMenuLink>
                        <DashboardMenuLink icon={Pencil} to={`/dashboard/consultants/edit-consultant/${consultantId}`}>
                            Edit Consultant
                        </DashboardMenuLink>
                        <DashboardMenuButton danger icon={Trash2} onClick={() => setIsOpen(true)}>
                            Delete Consultant
                        </DashboardMenuButton>
                    </DashboardActionMenuPanel>
                </Transition>
            </Menu>

        </div>
    )
}

export default ConsultantDropdown

